const Button = ({title, color = '#141414', onClick}: {title: string, color: string, onClick?: () => void}) => {
    return <a className="header-button" style={{
        color
    }} onClick={onClick}>
        {title}
    </a>
}

export default Button